import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserProgress } from '../models/user-progress';
import { Achievement } from '../models/achievement';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GamificationService {
    private readonly API_URL = 'api/gamification';
    private userProgressSubject = new BehaviorSubject<UserProgress>(new UserProgress());
    
    constructor(private http: HttpClient) {
        this.inizializzaProgresso();
    }

    private inizializzaProgresso() {
        // Carica il progresso dell'utente dal server
        this.http.get<UserProgress>(`${this.API_URL}/progress`)
            .subscribe(progress => this.userProgressSubject.next(progress));
    }

    aggiornaProgresso(punti: number) {
        const progressoAttuale = this.userProgressSubject.value;
        progressoAttuale.puntiTotali += punti;
        progressoAttuale.livello = this.calcolaLivello(progressoAttuale.puntiTotali);

        // Aggiorna sul server
        this.http.post<UserProgress>(`${this.API_URL}/progress`, progressoAttuale)
            .subscribe(updatedProgress => {
                this.userProgressSubject.next(updatedProgress);
                this.verificaAchievement();
            });
    }

    verificaAchievement() {
        const progressoAttuale = this.userProgressSubject.value;
        
        // Definizione degli achievement
        const achievements = [
            {
                id: 1,
                nome: "Primo Passo",
                puntiNecessari: 100,
                verificaCondizione: () => progressoAttuale.puntiTotali >= 100
            },
            {
                id: 2,
                nome: "Studente Dedicato",
                puntiNecessari: 500,
                verificaCondizione: () => progressoAttuale.puntiTotali >= 500
            },
            {
                id: 3,
                nome: "Maestro del Sapere",
                puntiNecessari: 1000,
                verificaCondizione: () => progressoAttuale.puntiTotali >= 1000
            }
        ];

        // Verifica e assegna achievement
        achievements.forEach(achievement => {
            if (achievement.verificaCondizione() && 
                !progressoAttuale.badge.includes(achievement.nome)) {
                progressoAttuale.badge.push(achievement.nome);
                this.notificaAchievement(achievement);
            }
        });
    }

    calcolaLivello(punti: number): number {
        return Math.floor(Math.sqrt(punti / 100)) + 1;
    }

    private notificaAchievement(achievement: any) {
        // Implementa qui la logica per mostrare una notifica all'utente
        console.log(`Congratulazioni! Hai sbloccato: ${achievement.nome}`);
    }

    // Metodi per le sfide giornaliere
   

    completaSfida(sfidaId: number, puntiGuadagnati: number) {
        this.http.post(`${this.API_URL}/completa-sfida`, { sfidaId })
            .subscribe(() => {
                this.aggiornaProgresso(puntiGuadagnati);
            });
    }

    // Metodi per la classifica
  

    // Metodi per le streak di studio
    getUserProgress(): Observable<UserProgress> {
        return this.http.get<UserProgress>('/api/gamification/progress');
      }
    
      getSfideGiornaliere(): Observable<any[]> {
        return this.http.get<any[]>('/api/gamification/sfide');
      }
    
      getClassifica(): Observable<any[]> {
        return this.http.get<any[]>('/api/gamification/classifica');
      }
    /*
      aggiornaProgresso(punti: number): Promise<void> {
        return this.http.post<void>('/api/gamification/progress', { punti }).toPromise();
      }
    */
      aggiornaStreak(streak: number): Promise<void> {
        return this.http.post<void>('/api/gamification/streak', { streak }).toPromise();
      }
    /*
      verificaAchievement(): Promise<void> {
        return this.http.get<void>('/api/gamification/verifica-achievement').toPromise();
      }
*/
    private calcolaBonusStreak(streakData: any): number {
        // Implementa la logica per calcolare i punti bonus basati sulla streak
        const streakGiorni = streakData.giorni || 0;
        return Math.floor(streakGiorni / 7) * 50; // 50 punti bonus ogni 7 giorni di streak
    }

    // Getter per osservare i cambiamenti del progresso
 
}